import type { DifferentProps } from '@/components/claims/Different';
import type { HeroProps } from '@/components/claims/Hero';
import type { HowItWorksProps } from '@/components/claims/HowItWorks';
import type { StatsProps } from '@/components/claims/Stats';
import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';
import { config as enUsConfig } from '../us/en';

export interface Config extends BasePageConfig {
  hero: HeroProps;
  stats: StatsProps;
  howItWorks: HowItWorksProps;
  different: DifferentProps;
}

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    ...enUsConfig.seo,
    title: 'Comment se faire rembourser pour un sinistre | Assurance Lemonade',
    metaTitle: 'Comment se faire rembourser pour un sinistre | Assurance Lemonade',
    description:
      "Lemonade traite vos demandes de remboursement rapidement. Envoyez votre demande via l'app Lemonade et elle sera traitée instantanément, ou envoyée à un membre de notre équipe.",
  },
  hero: {
    title: 'Le secret derrière nos remboursements',
    subtitle:
      "Les remboursements sont traités par notre équipe et notre Intelligence Artificielle. Envoyez votre demande en quelques clics depuis l'app Lemonade.",
  },
  stats: {
    steps: [
      {
        ...enUsConfig.stats.steps[0],
        subtitle: 'le sinistre le plus rapidement traité',
      },
      {
        ...enUsConfig.stats.steps[1],
        subtitle: 'Note sur notre app pour les demandes de remboursement',
      },
      {
        ...enUsConfig.stats.steps[2],
        subtitle: 'des demandes sont traitées instantanément',
      },
    ],
  },
  howItWorks: {
    title: 'Comment faire une demande de remboursement',
    subtitle: 'Faites votre demande de remboursement à partir de votre téléphone - où vous voulez, quand vous voulez',
    darkBackground: true,
    steps: {
      ...enUsConfig.howItWorks.steps,
      claim_button: {
        ...enUsConfig.howItWorks.steps.claim_button,
        content: `Appuyez sur le bouton "<b>Sinistres</b>" dans l'app Lemonade`,
      },
      what_happened: {
        ...enUsConfig.howItWorks.steps.what_happened,
        content: "Expliquez-nous ce qu'il s'est passé",
      },
      anti_fraud: {
        ...enUsConfig.howItWorks.steps.anti_fraud,
        content: "Notre Chatbot fait fonctionner des dizaines d'algorithmes anti-fraude",
      },
      instantly_approved: {
        ...enUsConfig.howItWorks.steps.instantly_approved,
        content: 'Si votre demande est approuvée <b>instantanément</b>, vous serez remboursé(e)s en quelques minutes',
      },
      humans: {
        ...enUsConfig.howItWorks.steps.humans,
        content: `Si besoin, votre demande est transférée à notre <b>équipe dédiée</b> qui s'en occupera le plus rapidement possible`,
      },
    },
  },
  different: {
    title: 'Vous rembourser tout en ayant un impact social',
    subtitle: `Contrairement aux autres compagnies d'assurance, nous prélevons des frais fixes sur votre cotisation, utilisons le reste pour rembourser vos sinistres, et <a href="/fr/giveback">redistribuons</a> l'argent qui reste aux causes qui vous tiennent à cœur. Nous ne gagnons rien à retarder ou à refuser des demandes d'indemnisation, c'est pourquoi nous les traitons <a href="/fr/faq#claims">rapidement et équitablement</a>.`,
    cta: {
      label: 'Consultez nos prix',
    },
  },
};
